import * as Blockly from 'blockly/core';
import { blockIcon } from '@/(routers)/boards/editor/block/blockFactory';
import { defineMutableBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const COLOR = CATEGORIES.file.color;

function appendHeader(block: Blockly.Block): void {
    block
        .appendDummyInput('HEADER')
        .appendField(blockIcon({ src: '/images/block/sdcard.svg', size: 65 }), 'ICON')
        .appendField(new FieldStyledLabel('SDカード', { fontSize: 15, fontWeight: 'bold' }))
        .appendField(new FieldStyledBadgeLabel('クリア', 55))
        .appendField(' ファイル名')
        .appendField(
            new FieldOperatorDropdown([
                { value: 'data_1', label: 'data_1' },
                { value: 'data_2', label: 'data_2' },
                { value: 'data_3', label: 'data_3' },
                { value: 'data_4', label: 'data_4' },
                { value: 'data_5', label: 'data_5' },
            ]),
            'FILENAME',
        )
        .appendField(
            new FieldOperatorDropdown([
                { value: 'txt', label: '.txt' },
                { value: 'csv', label: '.csv' },
                { value: 'tsv', label: '.tsv' },
            ]),
            'EXT',
        )
        .appendField('のデータをクリアする ');
}

defineMutableBlock({
    type: 'sdcard_clear',
    colour: COLOR,
    tooltip: 'SDカードのファイルをクリアします',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,

    init(this: Blockly.Block) {
        this.setColour(COLOR);
        this.setTooltip('SDカードのファイルをクリアします');
        this.setMovable(true);
        this.setDeletable(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        appendHeader(this);
    },

    mutationToDom(this: Blockly.Block): Element {
        const container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('filename', this.getFieldValue('FILENAME') ?? 'data_1');
        container.setAttribute('ext', this.getFieldValue('EXT') ?? 'txt');
        return container;
    },

    domToMutation(this: Blockly.Block, xml: Element): void {
        if (this.getInput('HEADER')) this.removeInput('HEADER');

        const filename = xml.getAttribute('filename') ?? 'data_1';
        const ext = xml.getAttribute('ext') ?? 'txt';

        appendHeader(this);

        requestAnimationFrame(() => {
            (this.getField('FILENAME') as FieldOperatorDropdown | null)?.setValue(filename);
            (this.getField('EXT') as FieldOperatorDropdown | null)?.setValue(ext);
            (this as Blockly.BlockSvg).render();
        });
    },
});
